/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useContext } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import toast from "react-hot-toast";
import { MdCheckCircle, MdNumbers, MdVpnKey } from "react-icons/md";
import { AuthContext } from "../../../context";
import PackageService from "../../../services/package.service";

const CreatePackage = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const { user } = useContext(AuthContext);
  const editItem = state?.item || null;

  const [form, setForm] = useState({
    number: "",
    internal_code: "",
  });
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [savedPackage, setSavedPackage] = useState(null);

  useEffect(() => {
    if (editItem) {
      setForm({
        number: editItem.number || "",
        internal_code: editItem.internal_code || "",
      });
    }
  }, [editItem]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "internal_code" && value.length > 8) return;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.number) {
      toast.error("El número de BL es requerido");
      return;
    }

    setLoading(true);
    try {
      if (editItem) {
        const res = await PackageService.admin.update({
          ...form,
          package_id: editItem.id,
        });
        setSavedPackage(res.package);
        setShowModal(true);
      } else {
        const res = await PackageService.admin.create({
          ...form,
          user_id: user?.id,
        });
        setSavedPackage(res.package);
        setShowModal(true);
      }
    } catch (error) {
      toast.error("Error al procesar el BL");
    } finally {
      setLoading(false);
    }
  };

  const handleCloseModal = () => {
    setShowModal(false);
    navigate(-1);
  };

  const handleNextSteps = () => {
    setShowModal(false);
    // Asumiendo que la ruta a productos es /admin/products y pasamos el package por state
    navigate("/admin/products", { state: { package: savedPackage } });
  };

  return (
    <div className="max-w-3xl mx-auto py-6 px-4 md:px-8">
      {/* SUCCESS MODAL */}
      {showModal && (
        <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/40 backdrop-blur-sm px-4">
          <div className="bg-white rounded-2xl w-full max-w-sm p-8 shadow-2xl flex flex-col items-center text-center animate-fade-in-up">
            <MdCheckCircle className="text-green-500 mb-4" size={70} />
            <h2 className="text-2xl font-bold text-gray-900 mb-2">
              BL {savedPackage?.number}
            </h2>
            <p className="text-gray-600 mb-8">
              {editItem ? "Editado" : "Registrado"} de forma exitosa
            </p>

            <div className="w-full space-y-3">
              {!editItem && (
                <button
                  type="button"
                  onClick={handleNextSteps}
                  className="w-full bg-[#1D3B8B] text-white font-bold py-3 px-4 rounded-xl shadow-md hover:bg-[#152a66] transition-colors"
                >
                  Cargar listado de contenido
                </button>
              )}
              <button
                type="button"
                onClick={handleCloseModal}
                className="w-full bg-gray-100 text-gray-800 font-bold py-3 px-4 rounded-xl hover:bg-gray-200 transition-colors"
              >
                Cerrar
              </button>
            </div>
          </div>
        </div>
      )}

      {/* FORMULARIO */}
      <div className="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden flex flex-col h-full min-h-[500px]">
        <div className="p-6 md:p-8 flex-1">
          <h2 className="text-xl font-bold text-gray-800 uppercase mb-6">
            {editItem ? "Editar" : "Registrar"} BL
          </h2>

          <div className="space-y-6">
            <div>
              <label className="block text-sm font-bold text-gray-700 uppercase mb-2">
                Número
              </label>
              <div className="flex items-center bg-white border border-gray-200 rounded-xl px-4 py-3 focus-within:ring-2 focus-within:ring-[#1D3B8B] focus-within:border-transparent transition-all shadow-sm">
                <MdNumbers className="text-gray-400 mr-3 shrink-0" size={22} />
                <input
                  type="text"
                  name="number"
                  value={form.number}
                  onChange={handleChange}
                  placeholder="Número de BL"
                  className="bg-transparent w-full outline-none text-gray-800 text-lg"
                  autoFocus
                />
              </div>
            </div>

            <div>
              <label className="block text-sm font-bold text-gray-700 uppercase mb-2">
                Código Interno (Opcional)
              </label>
              <div className="flex items-center bg-white border border-gray-200 rounded-xl px-4 py-3 focus-within:ring-2 focus-within:ring-[#1D3B8B] focus-within:border-transparent transition-all shadow-sm">
                <MdVpnKey className="text-gray-400 mr-3 shrink-0" size={22} />
                <input
                  type="text"
                  name="internal_code"
                  value={form.internal_code}
                  onChange={handleChange}
                  maxLength={8}
                  placeholder="Código Interno"
                  className="bg-transparent w-full outline-none text-gray-800 text-lg"
                />
              </div>
              <p className="text-xs text-gray-400 mt-2 ml-1">
                Máximo 8 caracteres
              </p>
            </div>
          </div>
        </div>

        {/* BOTONES INFERIORES */}
        <div className="flex border-t border-gray-100 bg-gray-50">
          <button
            type="button"
            onClick={() => navigate(-1)}
            disabled={loading}
            className="flex-1 py-4 font-bold text-gray-600 uppercase hover:bg-gray-200 transition-colors"
          >
            Cerrar
          </button>
          <button
            type="button"
            onClick={handleSubmit}
            disabled={loading}
            className="flex-1 py-4 font-bold text-white bg-[#1D3B8B] uppercase hover:bg-[#152a66] transition-colors disabled:opacity-70"
          >
            {loading ? "Guardando..." : "Guardar"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default CreatePackage;
